export default {"src":"/_next/static/media/reward_64.1f164ea1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};